import { useTranslation } from 'react-i18next';
import { Direction } from '@/api';
import { noop } from 'lodash';
import cx from 'classnames';

import { RiskKeys } from '@/config';
import SignalBadge from '@/components/SignalBadge/SignalBadge';

import { TransactionAlertsTableValue } from '../TransactionAlertsTableValue/TransactionAlertsTableValue';
import { TransactionAlertsEditValue } from '../TransactionAlertsEditModal/TransactionAlertsEditModal.constants';
import styles from './TransactionAlertsTableRow.module.sass';

export type AlertTableValue = {
  direct: number | null;
  indirect: number | null;
};

interface TransactionAlertsTableRowInterface {
  isActive?: boolean;
  isEditable?: boolean;
  isClearable?: boolean;
  category: RiskKeys;
  direction: Direction;
  low?: AlertTableValue;
  medium?: AlertTableValue;
  high?: AlertTableValue;
  severe?: AlertTableValue;
  onClearCategory?: () => void;
  onEdit?: (col: TransactionAlertsEditValue) => void;
}

export const TransactionAlertsTableRow = ({
  isActive = false,
  isEditable = false,
  isClearable = true,
  category,
  direction,
  low,
  medium,
  high,
  severe,
  onClearCategory = noop,
  onEdit = noop,
}: TransactionAlertsTableRowInterface) => {
  const { t } = useTranslation();

  const classes = cx(styles.row, {
    [styles['is-active']]: isActive,
  });

  return (
    <div className={classes}>
      <div className={styles.category}>
        <SignalBadge value={category} />
      </div>

      <div className={styles.content}>
        <div className={styles.low}>
          <TransactionAlertsTableValue
            isEditable={isEditable}
            direct={low?.direct ?? null}
            indirect={low?.indirect ?? null}
            onClick={() =>
              onEdit({
                category,
                alertGrade: 'low',
                direction,
                direct: low?.direct ?? null,
                indirect: low?.indirect ?? null,
              })
            }
          />
        </div>

        <div className={styles.medium}>
          <TransactionAlertsTableValue
            isEditable={isEditable}
            direct={medium?.direct ?? null}
            indirect={medium?.indirect ?? null}
            onClick={() =>
              onEdit({
                category,
                alertGrade: 'medium',
                direction,
                direct: medium?.direct ?? null,
                indirect: medium?.indirect ?? null,
              })
            }
          />
        </div>

        <div className={styles.high}>
          <TransactionAlertsTableValue
            isEditable={isEditable}
            direct={high?.direct ?? null}
            indirect={high?.indirect ?? null}
            onClick={() =>
              onEdit({
                category,
                alertGrade: 'high',
                direction,
                direct: high?.direct ?? null,
                indirect: high?.indirect ?? null,
              })
            }
          />
        </div>

        <div className={styles.severe}>
          <TransactionAlertsTableValue
            isEditable={isEditable}
            direct={severe?.direct ?? null}
            indirect={severe?.indirect ?? null}
            onClick={() =>
              onEdit({
                category,
                alertGrade: 'severe',
                direction,
                direct: severe?.direct ?? null,
                indirect: severe?.indirect ?? null,
              })
            }
          />
        </div>
      </div>

      <div className={styles.actions}>
        {isClearable && (
          <button
            type="button"
            className={styles.clear}
            onClick={onClearCategory}
          >
            {t('translation.btn_clear')}
          </button>
        )}
      </div>
    </div>
  );
};
